import React, { useState, useEffect, useRef } from "react";
import moment from "moment";
import { Select, message } from "antd";

const { Option } = Select;

const StatusBadgeHr = ({ item, api, hideLateAbsent = false }) => {
  const [itemStatus, setItemStatus] = useState(String(item.status));
  const [pendingStatus, setPendingStatus] = useState(null);
  const closeBtnRef = useRef(null);

  useEffect(() => {
    setItemStatus(String(item.status));
  }, [item.status]);

  const getBackgroundColor = () => {
    if (itemStatus === "1") return "#d4edda"; // ✅ light green
    if (itemStatus === "2") return "#f8d7da"; // ✅ light red
    if (itemStatus === "3") return "#f2fffb"; // ✅ light cyan for Late-In
    if (itemStatus === "4") return "#ffebee"; // ✅ light red/pink for Absent
    return "#fdfd96"; // ✅ Pending (0)
  };

  const getTextColor = () => {
    if (itemStatus === "1") return "#155724";
    if (itemStatus === "2") return "#721c24";
    if (itemStatus === "3") return "#0bc698";
    if (itemStatus === "4") return "#c62828";
    return "#856404"; // ✅ Pending (0)
  };

  // ✅ Conditional locking logic (locked if status is fixed OR if backend says it's locked)
  const isLocked = itemStatus === "1" || itemStatus === "2" || (itemStatus === "3" && !hideLateAbsent) || (itemStatus === "4" && !hideLateAbsent) || item.is_locked;

  const performUpdate = (statusToSet) => {
    api(item.id, statusToSet)
      .then((res) => {
        if (res.data === "Un-Athunticated request") {
          message.error("Session expired! Please log in again.");
          return;
        }

        if (res.Good === true || res.data?.Good === true || res.success === true) {
          setItemStatus(statusToSet);
          message.success("Status updated successfully!");
        } else {
          message.warning(res.data?.message || res.message || "Failed to update status.");
        }
      })
      .catch((err) => {
        console.error("Status update error:", err);
        message.error("An error occurred while updating status.");
      });
  };

  const handleStatusChange = (newStatus) => {
    if ((newStatus === "1" || newStatus === "2") && !isLocked) {
      setPendingStatus(newStatus);
      const modalElement = document.getElementById(`statusModal-${item.id}`);
      if (modalElement) {
        const modal = new window.bootstrap.Modal(modalElement);
        modal.show();
      }
    } else {
      performUpdate(newStatus);
    }
  };

  const confirmStatusChange = () => {
    if (pendingStatus) {
      performUpdate(pendingStatus);

      // Close modal using bootstrap instance or click the hidden close button
      if (closeBtnRef.current) {
        closeBtnRef.current.click();
      }
    }
    setPendingStatus(null);
  };

  return (
    <>
      <style>{`
        .status-badge-select.ant-select .ant-select-selector {
          border: 1px solid #ced4da !important;
          border-radius: 5px !important;
          height: 30px !important;
          display: flex !important;
          align-items: center !important;
          box-shadow: none !important;
          background-color: #f8f9fa !important;
        }
        .status-badge-select.ant-select .ant-select-selection-item {
          color: #212529 !important;
          font-weight: 500 !important;
          font-size: 12px !important;
          line-height: 28px !important;
        }
        .status-badge-select.ant-select .ant-select-arrow {
          color: #666 !important;
        }
      `}</style>
      <Select
        value={itemStatus}
        onChange={handleStatusChange}
        className="shift-table-select status-badge-select"
        popupClassName="shift-table-select-dropdown"
        disabled={isLocked}
        style={{
          width: "100%",
        }}
      >
        <Option value="0">Pending</Option>
        <Option value="1">Approved</Option>
        <Option value="2">Disapproved</Option>
        {!hideLateAbsent && <Option value="3">Late-In</Option>}
        {!hideLateAbsent && <Option value="4">Absent</Option>}
      </Select>

      {/* Bootstrap Confirmation Modal */}
      <div id={`statusModal-${item.id}`} className="modal fade" tabIndex={-1} role="dialog" aria-hidden="true" data-bs-keyboard="false">
        <div className="modal-dialog modal-dialog-centered" style={{ display: "flex", alignItems: "center", minHeight: "calc(100vh - 3.5rem)", margin: "auto" }}>
          <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
            <div className="modal-header border-0 pb-1">
              <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Change Status</h5>
              <button type="button" className="btn-close" ref={closeBtnRef} data-bs-dismiss="modal" aria-label="Close" onClick={() => setPendingStatus(null)} />
            </div>
            <div className="modal-body pt-2 pb-2">
              <p style={{ fontSize: "14px", color: "#1D1D1D", marginBottom: "6px" }}>Are you sure you want to change the status to <strong>{pendingStatus === "1" ? "Approved" : "Disapproved"}</strong>?</p>
              <p style={{ fontSize: "13px", color: "#ff4d4f", marginBottom: 0 }}>
                <i className="uil uil-exclamation-triangle me-1" />
                Once {pendingStatus === "1" ? "Approved" : "Disapproved"}, You can't change this status again.
              </p>
            </div>
            <div className="modal-footer border-0 pt-1">
              <button type="button" className="btn waves-effect" data-bs-dismiss="modal" onClick={() => setPendingStatus(null)} style={{ borderRadius: "5px", fontSize: "13px", height: "34px", backgroundColor: "#F2F2F2", borderColor: "#F2F2F2", color: "#212529", padding: "0 20px", fontWeight: "600" }}>
                No
              </button>
              <button type="button" className="btn waves-effect waves-light" onClick={confirmStatusChange} style={{ borderRadius: "5px", fontSize: "13px", height: "34px", backgroundColor: "#0DDFAB", borderColor: "#0DDFAB", color: "white", padding: "0 20px", fontWeight: "600" }}>
                Yes
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StatusBadgeHr;
